import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import './Brick.css';
class Brick extends Component {
  constructor(props) {
    super(props);
    if (this.props.selected === "undefined") {
      this.props.selected = false;
    }
  }

  ratioChanged = (e) => {
    this.props.ratioChanged(this.props, e.target.value);
  }
  brickClicked = () => {
    if (!this.props.empty) {
      this.props.onBrickClick(this.props);
    }

  }

  render() {
    return (
      <div style={{ display: "inline-block" }}>
        <div className={'brick' + (this.props.selected ? ' brick-selected' : '') + (this.props.empty ? ' brick-empty' : '')} onClick={this.brickClicked}>
          {!this.props.empty &&
            <div className="brick-title">{this.props.name}</div>
          }
          {!this.props.empty &&
            <img src={this.props.images + '/' + this.props.id + '.jpg'} alt={this.props.name} title={this.props.name} />
          }
        </div>
        {this.props.showRatio &&
          <div className="ratioSelect">
            <FormGroup>
              {!this.props.ratioEnabled ?
                <FormControl type="select" disabled componentClass="select"></FormControl> :
                <FormControl type="select" value={this.props.ratio} style={{ padding: 0 }} onChange={this.ratioChanged} componentClass="select" >
                  <option value="0">0%</option>
                  <option value="10">10%</option>
                  <option value="20">20%</option>
                  <option value="30">30%</option>
                  <option value="40">40%</option>
                  <option value="50">50%</option>
                  <option value="60">60%</option>
                  <option value="70">70%</option>
                  <option value="80">80%</option>
                  <option value="90">90%</option>
                  <option value="100">100%</option>
                </FormControl>
              }
            </FormGroup>
          </div>
        }
      </div>

    );
  }
}

export default Brick;
